import http from "@/http-common";
import security from './security';

class DownloadService {

    downloadUndecodedDatagram() {

        let object = security.getConfig();
        object.params = {decode_status: false};

        http.get('/datagram', object)
        .then(data => {

            data = JSON.stringify(data.data,null, 2)
            let date=new Date().toISOString()

            const downloadUrl = window.URL.createObjectURL(new Blob([data], {type: 'application/octet-stream'}));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `${date}_tramas_acs.json`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
          }).catch(console.error)
    }

}

export default new DownloadService();